import { render, staticRenderFns } from "./MarketPlaceProductCard.vue?vue&type=template&id=956c00ca&scoped=true"
import script from "./MarketPlaceProductCard.vue?vue&type=script&lang=js"
export * from "./MarketPlaceProductCard.vue?vue&type=script&lang=js"
import style0 from "./MarketPlaceProductCard.vue?vue&type=style&index=0&id=956c00ca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "956c00ca",
  null
  
)

export default component.exports